function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9672 52.9772L12.0272 52.9272C12.0272 52.9272 11.9872 52.8972 11.9672 52.8872V52.9772Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M43.1972 3.06723C28.3172 -4.22277 10.3572 1.92723 3.06723 16.7972C-4.22277 31.6672 1.92723 49.6372 16.7972 56.9272C31.6672 64.2172 49.6372 58.0672 56.9272 43.1872C64.2172 28.3172 58.0672 10.3472 43.1872 3.05723L43.1972 3.06723ZM12.0172 52.9272L11.9572 52.9772V52.8872L12.0072 43.4272L27.7472 30.7772L24.8772 28.1172L12.5772 16.6872L12.5972 7.78723V7.02723L38.4472 30.8272L11.9972 52.9372L12.0172 52.9272ZM32.0772 49.8672L32.4172 41.6772L46.3272 31.3372L33.7872 18.7672L34.1172 10.4772L55.5172 31.7272L32.0672 49.8672H32.0772Z",
  fill: "white"
});

function SvgVectorIconWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorIconWhite);
export default __webpack_public_path__ + "static/media/VectorIconWhite.3e4ec480.svg";
export { ForwardRef as ReactComponent };